var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_5043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.04752 22.6492C17.1042 22.6492 22.0578 15.1458 22.0578 8.63896C22.0578 8.42584 22.0578 8.21368 22.0434 8.00248C23.007 7.30543 23.8389 6.44236 24.5 5.45368C23.6014 5.85208 22.648 6.11323 21.6718 6.2284C22.6998 5.61309 23.4692 4.64518 23.8366 3.50488C22.8701 4.07849 21.8126 4.4827 20.7099 4.70008C19.9675 3.91065 18.9856 3.38792 17.9162 3.21276C16.8468 3.03761 15.7494 3.21979 14.794 3.73113C13.8385 4.24247 13.0782 5.05445 12.6307 6.04143C12.1833 7.0284 12.0735 8.13534 12.3186 9.19096C10.3609 9.09276 8.44576 8.58399 6.69745 7.69768C4.94915 6.81138 3.40676 5.56734 2.1704 4.04632C1.54073 5.13031 1.34787 6.41355 1.6311 7.63474C1.91433 8.85593 2.65234 9.92327 3.69488 10.6194C2.91123 10.5965 2.14465 10.3851 1.46 10.0031V10.0655C1.46031 11.2024 1.85385 12.3041 2.57387 13.1839C3.29389 14.0637 4.29606 14.6673 5.4104 14.8924C4.68548 15.0901 3.92487 15.119 3.18704 14.9769C3.50181 15.9552 4.11443 16.8107 4.93924 17.4238C5.76405 18.0369 6.75983 18.377 7.78736 18.3964C6.76644 19.1989 5.59731 19.7922 4.34687 20.1424C3.09643 20.4926 1.78921 20.5928 0.5 20.4374C2.75183 21.8824 5.37192 22.6489 8.04752 22.6454",
    fill: "#1DA1F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_5043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.898438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.dee8eb5a232bd09fd6e78869197aec2e.svg";
export { ForwardRef as ReactComponent };